import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import './AppearWrapper.scss';

export default function AppearWrapper(props) {
  const { className, style, isOpen, children } = props;
  return (
    <div style={{ ...style }} className={cn(className, `appear-wrapper-${isOpen ? 'visible' : 'hidden'}`)}>
      {children}
    </div>
  );
}

AppearWrapper.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isOpen: PropTypes.bool,
};
